'use client'
import {createContext} from "react";
import {useContextStrict} from "@web-libs/core/context/context.functions";
import {UseChatConcern} from "@web-libs/features/chat/application/use-chat.interface";

export const ChatContext = createContext<UseChatConcern|null>(null)

export const useChat = (): UseChatConcern => {
    return useContextStrict(ChatContext)
}
